module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Regular-d67583853f440d25cbf9b201197bd912.woff2";